import axios from "axios";
import { toast } from "sonner";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

const api = axios.create({
  baseURL: API,
});

api.interceptors.request.use((config) => {
  const t = sessionStorage.getItem("pim_token") || localStorage.getItem("pim_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

const HOME_BY_ROLE = { admin: "/admin", empresa: "/admin", montadora: "/admin", montador: "/montador" };

// Se a sessão foi trocada em outra aba (papel diferente), redireciona para o painel correto
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const detail = err?.response?.data?.detail;
    // BLOCO 3C: token de sessão Demo encerrada → 410 em qualquer rota; limpa a sessão local e volta ao login
    if (err?.response?.status === 410 && typeof detail === "string" && detail.includes("demonstração foi encerrada")) {
      sessionStorage.removeItem("pim_token");
      sessionStorage.removeItem("pim_role");
      if (!window.location.pathname.startsWith("/login")) {
        toast.error(detail);
        setTimeout(() => window.location.assign("/login"), 1200);
        return new Promise(() => {});
      }
    }
    if (err?.response?.status === 403 && typeof detail === "string" &&
        detail.startsWith("Acesso negado. Papel requerido")) {
      try {
        const me = await axios.get(`${API}/auth/me`, {
          headers: { Authorization: `Bearer ${sessionStorage.getItem("pim_token") || localStorage.getItem("pim_token")}` },
        });
        const cachedRole = localStorage.getItem("pim_role");
        if (me.data?.role && cachedRole && me.data.role !== cachedRole) {
          localStorage.setItem("pim_role", me.data.role);
          window.location.assign(HOME_BY_ROLE[me.data.role] || "/login");
          return new Promise(() => {});
        }
      } catch {}
    }
    return Promise.reject(err);
  }
);

export default api;

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Erro desconhecido";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" • ");
  return JSON.stringify(d);
}
